module.exports = "/images/mx.png?0fb96afd443b158217fa36bc6de85016";